export default __webpack_public_path__ + "static/media/img-0681-bosnia-full-face.ce76255c.png";